module.exports = __webpack_public_path__ + "img/wechat.262ed1ce.png";